import React, { FC, ReactNode } from "react";
import useOidcAuth from "../../hooks/useOidcAuth";

type Props = {
  children: ReactNode;
};

const OidcProvider: FC<Props> = ({ children }) => {
  useOidcAuth(true);

  return <>{children}</>;
};

export default OidcProvider;
